/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._1bHrqEN91d%7Bflex-basis%3A100%25%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._0KLXruG6qS%7Bbackground-color%3Avar(--ds-background-accent-gray-subtler%2C%23dddee1)%7D%0A._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D%0A._1uo2ZfTcEg%7Bclip-path%3Apolygon(45%25%201.33975%25%2C46.5798%25%20.60307%25%2C48.26352%25%20.15192%25%2C50%25%200%2C51.73648%25%20.15192%25%2C53.4202%25%20.60307%25%2C55%25%201.33975%25%2C89.64102%25%2021.33975%25%2C91.06889%25%2022.33956%25%2C92.30146%25%2023.57212%25%2C93.30127%25%2025%25%2C94.03794%25%2026.5798%25%2C94.48909%25%2028.26352%25%2C94.64102%25%2030%25%2C94.64102%25%2070%25%2C94.48909%25%2071.73648%25%2C94.03794%25%2073.4202%25%2C93.30127%25%2075%25%2C92.30146%25%2076.42788%25%2C91.06889%25%2077.66044%25%2C89.64102%25%2078.66025%25%2C55%25%2098.66025%25%2C53.4202%25%2099.39693%25%2C51.73648%25%2099.84808%25%2C50%25%20100%25%2C48.26352%25%2099.84808%25%2C46.5798%25%2099.39693%25%2C45%25%2098.66025%25%2C10.35898%25%2078.66025%25%2C8.93111%25%2077.66044%25%2C7.69854%25%2076.42788%25%2C6.69873%25%2075%25%2C5.96206%25%2073.4202%25%2C5.51091%25%2071.73648%25%2C5.35898%25%2070%25%2C5.35898%25%2030%25%2C5.51091%25%2028.26352%25%2C5.96206%25%2026.5798%25%2C6.69873%25%2025%25%2C7.69854%25%2023.57212%25%2C8.93111%25%2022.33956%25%2C10.35898%25%2021.33975%25)%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._1uo2ZfOLYo%7Bclip-path%3Ainherit%7D%0A._00EA0eiObl%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D%0A._3IONCnIZbP%7Bimage-rendering%3Aauto%7D%0A._27VeLCEGCh%20svg%7Bwidth%3A15.4px%7D%0A._2Qxi4nQSd4%20svg%7Bheight%3A17.17px%7D%0A._27VeLC1R6D%20svg%7Bwidth%3A23.11px%7D%0A._2Qxi4n7qhK%20svg%7Bheight%3A1.61pc%7D%0A._27VeLCU2XU%20svg%7Bwidth%3A30.81px%7D%0A._2Qxi4nRlO4%20svg%7Bheight%3A34.34px%7D%0A._27VeLCs3iu%20svg%7Bwidth%3A38.51px%7D%0A._2Qxi4nNmyB%20svg%7Bheight%3A42.93px%7D%0A._27VeLCOhVQ%20svg%7Bwidth%3A92.44px%7D%0A._2Qxi4nHWFU%20svg%7Bheight%3A6.44pc%7D%0A._27VeLCc73x%20svg%7Bwidth%3A123.25px%7D%0A._2Qxi4nSk01%20svg%7Bheight%3A137.39px%7D%0A._27VeLCey7F%20svg%7Bwidth%3A1pc%7D%0A._2Qxi4ney7F%20svg%7Bheight%3A1pc%7D%0A._27VeLCSPN1%20svg%7Bwidth%3A20px%7D%0A._2Qxi4nSPN1%20svg%7Bheight%3A20px%7D%0A._27VeLCoWWg%20svg%7Bwidth%3A24px%7D%0A._2Qxi4noWWg%20svg%7Bheight%3A24px%7D%0A._27VeLCUofl%20svg%7Bwidth%3A2pc%7D%0A._2Qxi4nUofl%20svg%7Bheight%3A2pc%7D%0A._27VeLCUF4f%20svg%7Bwidth%3A40px%7D%0A._2Qxi4nUF4f%20svg%7Bheight%3A40px%7D%0A._27VeLCJgOI%20svg%7Bwidth%3A6pc%7D%0A._2Qxi4nJgOI%20svg%7Bheight%3A6pc%7D%0A._27VeLCNNui%20svg%7Bwidth%3A8pc%7D%0A._2Qxi4nNNui%20svg%7Bheight%3A8pc%7D%0A._0bjKvDcjp5%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D%0A._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D");











































import { type FC, useEffect, useState } from 'react';
import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import PersonIcon from '@atlaskit/icon/core/person';
import ReleaseIcon from '@atlaskit/icon/core/release';
import { type AppearanceType, type SizeType } from '../types';
interface AvatarImageProps {
  appearance: AppearanceType;
  UNSAFE_isUpdatedGeometry?: boolean;
  size: SizeType;
  alt?: string;
  src?: string;
  testId?: string;
  imgLoading?: 'lazy' | 'eager';
}
const styles = {
  image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d",
  icon: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0KLXruG6qS",
  circle: "_0bjKvDS5Zs",
  hexagon: "_1uo2ZfTcEg",
  updatedHexagonIcon: "_0hPCNLDIqT _37wbyuDIqT",
  updatedHexagonImage: "_1uo2ZfOLYo _00EA0eiObl _3IONCnIZbP"
};
const borderRadiusMap = {
  xxsmall: "_0bjKvDcjp5",
  xsmall: "_0bjKvDcjp5",
  UNSAFE_xsmall: "_0bjKvDcjp5",
  small: "_0bjKvDcjp5",
  medium: "_0bjKvDKxmn",
  large: "_0bjKvDKxmn",
  xlarge: "_0bjKvDKTcp",
  xxlarge: "_0bjKvDyzSk"
};
const nestedSvgStylesMap = {
  xxsmall: "_27VeLCey7F _2Qxi4ney7F",
  xsmall: "_27VeLCey7F _2Qxi4ney7F",
  UNSAFE_xsmall: "_27VeLCSPN1 _2Qxi4nSPN1",
  small: "_27VeLCoWWg _2Qxi4noWWg",
  medium: "_27VeLCUofl _2Qxi4nUofl",
  large: "_27VeLCUF4f _2Qxi4nUF4f",
  xlarge: "_27VeLCJgOI _2Qxi4nJgOI",
  xxlarge: "_27VeLCNNui _2Qxi4nNNui"
};

// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const updatedHexagonNestedSvgStylesMap = {
  xxsmall: "_27VeLCEGCh _2Qxi4nQSd4",
  small: "_27VeLC1R6D _2Qxi4n7qhK",
  medium: "_27VeLCU2XU _2Qxi4nRlO4",
  large: "_27VeLCs3iu _2Qxi4nNmyB",
  xlarge: "_27VeLCOhVQ _2Qxi4nHWFU",
  xxlarge: "_27VeLCc73x _2Qxi4nSk01"
};

/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */
const AvatarImage: FC<AvatarImageProps> = ({
  alt = '',
  src,
  appearance,
  UNSAFE_isUpdatedGeometry,
  size,
  testId,
  imgLoading
}) => {
  const [hasImageErrored, setHasImageErrored] = useState(false);

  // If src changes, reset state
  useEffect(() => {
    setHasImageErrored(false);
  }, [src]);
  if (!src || hasImageErrored) {
    let renderedIcon: React.JSX.Element;
    switch (appearance) {
      case 'circle':
        renderedIcon = <PersonIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--person`} spacing="spacious" />;
        break;
      case 'hexagon':
        renderedIcon = <AiAgentIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--agent`} spacing="spacious" />;
        break;
      default: // historical default for safety
      case 'square':
        renderedIcon = <ReleaseIcon label={alt} color={"var(--ds-icon-subtle, #505258)"} testId={testId && `${testId}--ship`} spacing="spacious" />;
        break;
    }
    return <span className={ax([styles.icon, UNSAFE_isUpdatedGeometry ? updatedHexagonNestedSvgStylesMap[(size as 'xxsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge')] : nestedSvgStylesMap[size], UNSAFE_isUpdatedGeometry && styles.updatedHexagonIcon])}>
				{renderedIcon}
			</span>;
  }
  return <img loading={imgLoading} src={src} alt={alt} data-testid={testId && `${testId}--image`} onError={() => setHasImageErrored(true)} aria-hidden={!alt ? true : undefined} data-vc={testId ? `${testId}--image` : 'avatar-image'} data-ssr-placeholder-ignored className={ax([styles.image, borderRadiusMap[size], appearance === 'circle' && styles.circle, appearance === 'hexagon' && styles.hexagon, UNSAFE_isUpdatedGeometry && styles.updatedHexagonImage])} />;
};
export default AvatarImage;